import DetailsScreen from './DetailsScreen.container';

export default DetailsScreen;
